import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import CourseOverview from './pages/CourseOverview';
import ContentPage from './pages/ContentPage';
import CommunityPage from './pages/CommunityPage';
import AboutPage from './pages/AboutPage';

function App() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const toggle = () => setSidebarOpen((v) => !v);

  return (
    <Router>
      <div className="flex min-h-screen bg-white text-gray-900 font-sans">
        <Sidebar isOpen={sidebarOpen} onToggle={toggle} />

        <div className="flex-1 flex flex-col min-w-0">
          <Header sidebarOpen={sidebarOpen} onToggleSidebar={toggle} />
          <main className="flex-1 overflow-y-auto">
            <Routes>
              <Route path="/" element={<CourseOverview />} />
              <Route path="/content/:contentId" element={<ContentPage />} />
              <Route path="/community" element={<CommunityPage />} />
              <Route path="/about" element={<AboutPage />} />
            </Routes>
          </main>
        </div>
      </div>
    </Router>
  );
}

export default App;
